// @flow

import type { DiamondType } from '@types/diamond';

import { fullSizeShapeImagePath } from '@src/utils/images';

function rockWidth (diamond, height) {
  return Math.round(parseFloat(height) / diamond.length_width_ratio);
}

type PropsType = {
  diamond: DiamondType,
  height: number
};

const EnlargedDiamond = ({ diamond, height }: PropsType) => {
  return (
    <img
      src={fullSizeShapeImagePath(diamond)}
      style={{ width: rockWidth(diamond, height), height: `${height}px` }}
    />
  );
};

EnlargedDiamond.defaultProps = {
  height: 200
};

export default EnlargedDiamond;
